import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ResourceResponse } from "@/model/Resource/ResourceRequest";

export const UploadChecklistAttachment = () => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (request: { File: File; procedureId: number }) =>
			SATOSPortal.UploadManualChecklistStepImage(request),
		onMutate: (request) => {
			void queryClient.cancelQueries({
				queryKey: [
					ResourceQueryKeys.resource,
					ResourceQueryKeys.checklist,
					ResourceQueryKeys.attachment,
					request.procedureId,
				],
			});

			const previousValue: ResourceResponse | undefined =
				queryClient.getQueryData([
					ResourceQueryKeys.resource,
					ResourceQueryKeys.checklist,
					ResourceQueryKeys.attachment,
					request.procedureId,
				]);

			if (previousValue) {
				queryClient.setQueryData(
					[
						ResourceQueryKeys.resource,
						ResourceQueryKeys.checklist,
						ResourceQueryKeys.attachment,
						request.procedureId,
					],
					{
						...previousValue,
						Revision: previousValue.Revision + 1,
					},
				);
			}
		},
		onError: (_, variables, previousValue) => {
			queryClient.setQueryData(
				[
					ResourceQueryKeys.resource,
					ResourceQueryKeys.checklist,
					ResourceQueryKeys.attachment,
					variables.procedureId,
				],
				previousValue,
			);
		},
		onSettled: (variables) => {
			if (variables) {
				void queryClient.invalidateQueries({
					queryKey: [
						ResourceQueryKeys.resource,
						ResourceQueryKeys.checklist,
						ResourceQueryKeys.attachment,
					],
				});
			}
		},
	});
	return mutation.mutateAsync;
};

export class ResourceQueryKeys {
	static readonly resource = "resource";
	static readonly checklist = "checklist";
	static readonly attachment = "attachment";
}
